import { params } from "../../../hooks/game-room/handlegameRoom.js";
export function startConsumeProducer(producer) {
  const { socket } = params;
  socket.emit("createConsumeTransport", producer);
}
